// for localhost development
export let BASE_URL = "https://apicflex.technogenesis.in";
// for live development
// export let BASE_URL = "https://kebabapi.petalyellow.com"; 
// export let BASE_URL = "https://kebabapi.petalyellow.com/testing";  

